import { useQuery } from "@apollo/client";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SelectChangeEvent,
} from "@mui/material";
import { gql } from "../../__generated__";

type TagsSelectorProps = {
  tagIds: string[];
  setTagIds: (tagIds: string[]) => void;
};

export default function TagsSelector(props: TagsSelectorProps) {
  const { data, loading, error } = useQuery(GET_TAGS);
  const tags = data?.tags.records || [];

  function handleChange(event: SelectChangeEvent<string[]>) {
    const value = event.target.value;
    props.setTagIds(typeof value === "string" ? value.split(",") : value);
  }

  return (
    <FormControl
      size="small"
      variant="outlined"
      sx={{ width: "200px", backgroundColor: "white" }}
    >
      <InputLabel>Tags</InputLabel>
      <MuiSelect<string[]>
        multiple
        label="Tags"
        value={props.tagIds}
        onChange={handleChange}
        renderValue={(selected) =>
          tags
            .filter((tag) => selected.includes(tag.id))
            .map((tag) => tag.name)
            .join(", ")
        }
      >
        {loading && <MenuItem disabled>Loading</MenuItem>}
        {error && <MenuItem disabled>Error loading tags</MenuItem>}
        {!loading && !error && tags.length === 0 && (
          <MenuItem disabled>No tags available</MenuItem>
        )}
        {!loading &&
          !error &&
          tags.map((tag) => (
            <MenuItem key={tag.id} value={tag.id}>
              {tag.name}
            </MenuItem>
          ))}
      </MuiSelect>
    </FormControl>
  );
}

const GET_TAGS = gql(`
  query GetTags {
    tags(input: { hasPublishedProducts: true }) {
      records {
        id
        name
      }
    }
  }
`);
